// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JMfxneThpUFC69SJ9bk5 button{width:2.625rem}.cXbI4PoC9OCiqL0SsZZg{box-shadow:0px 0px 1.25rem rgba(0,71,136,.1019607843)}.cQAswlQ6ZHvk_d5Dkra9{font-size:1rem}`, "",{"version":3,"sources":["webpack://./services/client/src/components/WidgetInstruction/styles.module.scss"],"names":[],"mappings":"AAGE,6BACE,cAAA,CAIJ,sBACE,qDAAA,CAGF,sBACE,cAAA","sourcesContent":["@import '../../styles/global.scss';\n\n.abstract {\n  button {\n    width: pixel2rem(42);\n  }\n}\n\n.instruction {\n  box-shadow: 0px 0px pixel2rem(20) $dark-blue;\n}\n\n.second-heading {\n  font-size: pixel2rem(16);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"abstract": `JMfxneThpUFC69SJ9bk5`,
	"instruction": `cXbI4PoC9OCiqL0SsZZg`,
	"second-heading": `cQAswlQ6ZHvk_d5Dkra9`
};
export default ___CSS_LOADER_EXPORT___;
